import { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Paper from '@base/Paper/Paper';
import H3 from '@base/H3/H3';
import P1 from '@base/P1/P1';
import Button from '@base/Button/Button';
import imageHelper from '@utils/imageHelper';
import { showTTUCurtain } from '@actions/ttu';
import { TTU_POP_UP_CLICK } from '@constants/segment';
import { TalkState } from '@cont/Login/constants';
import { sendTTUEvents } from '@events/sendAnalytics';

const TTUContainer = styled(Paper)`
  width: 848px;
  margin: 160px auto;
  position: relative;
  @media (max-width: 70.95em) {
    margin: 80px auto;
    width: 728px;
  }
  @media (max-width: 47.95em) {
    display: none;
  }
`;

const StyledP1 = styled(P1)`
  margin-top: 8px;
  margin-bottom: 32px;
  color: ${({ theme }) => theme.colors.fontGrey};
`;

const Illustration = styled.img`
  position: absolute;
  right: 0;
  bottom: 35px;
  @media (max-width: 70.95em) {
    width: 96px;
    height: 80px;
  }
`;

const Banner = ({ goalDetails }) => {
  const dispatch = useDispatch();
  const showData = useSelector(({ ttu }) => ttu.showData);
  const meData = useSelector(({ auth }) => auth.me);
  let userType = showData.is_repeat_user ? 'Repeat' : 'New';
  if (
    !showData.is_repeat_user &&
    (showData.state === TalkState.NO_SHOW ||
      showData.state === TalkState.LOCAL_NO_SHOW)
  ) {
    userType = 'Scheduled';
  }
  const theme = useContext(ThemeContext);
  return (
    <TTUContainer>
      <H3 color={theme.colors.fontGrey}>
        {`Have questions about the ${goalDetails?.name || ''} subscription?`}
      </H3>
      <StyledP1>Our expert can answer your questions</StyledP1>
      <Illustration src={imageHelper.getImage('ttu_illustration.svg')} />
      <Button
        label="Talk to our expert"
        onClick={() => {
          dispatch(showTTUCurtain(true));
          sendTTUEvents(
            TTU_POP_UP_CLICK,
            {
              user_ttu_status: userType,
              source: 'Bottom Home Screen'
            },
            meData?.uid,
            meData?.username,
            goalDetails?.uid,
            goalDetails?.name
          );
        }}
      />
    </TTUContainer>
  );
};

export default Banner;

Banner.propTypes = {
  goalDetails: PropTypes.objectOf(PropTypes.any).isRequired
};
